<div class="coupons-main-page records-page">
    <div class="datatable-page-shell">
        <div class="records-page__hero coupons-main-hero">
            <div class="records-page__hero-primary">
                <div class="records-page__hero-headline">
                    <span class="records-page__hero-eyebrow">{{ 'COUPONS' | translate }}</span>
                    <h3 class="records-page__hero-title">{{ 'YOUR_COUPONS' | translate }}</h3>
                </div>
            </div>
            <div class="records-page__hero-aside" *ngIf="doWhat.isAdmin || doWhat.canCreate">
                <div class="records-page__hero-actions">
                    <button type="button" class="blue-button" (click)="onAddNew()">{{ 'ADD_COUPON' | translate }}</button>
                </div>
            </div>
        </div>

        <div class="details-tab-surface coupons-main-surface datatable-page-surface">
            <app-campaign-datatable class="records-page__table" [iShowDropdownAdd]="false" [iColumns]="columns" [iCanRead]="doWhat.canRead" [iCanWrite]="doWhat.canWrite" [iCanDelete]="doWhat.canDelete" [iRowLinkHandler]="getRowLink" (oDeleteRows)="deleteRows($event)"
                (oEditRow)="editRow($event)" [iData$]="couponsData" [iShowSelect]="false"></app-campaign-datatable>
        </div>
    </div> 
</div>
